import  { jwtDecode } from 'jwt-decode'
import { getCookie, eraseCookie } from '../api/helpers'

const getDecodedToken = () => {
  const token = getCookie("access")
  if (!token) return null;

  try {
    return jwtDecode(token);
  } catch (e) {
    console.error('Invalid JWT token', e)
    return null;
  }
};

const getTenantFromPath = () => {
  const match = window.location.pathname.match(/^\/([^\/]+)\/?/)
  return match ? match[1] : null;
};

export const checkTenantAndHandle = () => {
    const decoded = getDecodedToken()
    const currentTenant = getTenantFromPath()
    if (!decoded || !currentTenant) {
        console.warn('No token or tenant found.')
        return
    }

    if (decoded.tenant !== currentTenant) {
        if(currentTenant === "xogene" && decoded.tenant === "public"){
            return
        }
        else{
            console.warn(
            `Tenant mismatch: token tenant "${decoded.tenant}" vs path tenant "${currentTenant}"`
            );
            // Clear tokens
            eraseCookie('access')
            eraseCookie('refresh')
        }

        // Redirect to login page for the current tenant
        // window.location.href = `/${currentTenant}`
    }
};